import { render, staticRenderFns } from "./TalkForwardRecord.vue?vue&type=template&id=160c6717&scoped=true&"
import script from "./TalkForwardRecord.vue?vue&type=script&lang=js&"
export * from "./TalkForwardRecord.vue?vue&type=script&lang=js&"
import style0 from "./TalkForwardRecord.vue?vue&type=style&index=0&id=160c6717&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160c6717",
  null
  
)

export default component.exports